import { render } from "./carte.vue?vue&type=template&id=0c84858d"
const script = {}
script.render = render
/* custom blocks */
import block0 from "./carte.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(script)


export default script